import { ApiError, Offer } from "@blacknut/javascript-sdk/dist";

export enum LGActionTypes {
  OFFER_FETCH_REQUEST = "OFFER_FETCH_REQUEST",
  OFFER_FETCH_SUCCESS = "OFFER_FETCH_SUCCESS",
  OFFER_FETCH_ERROR = "OFFER_FETCH_ERROR",
}

export type LGAction =
  | {
      type: LGActionTypes.OFFER_FETCH_REQUEST;
      priceId: string;
    }
  | {
      type: LGActionTypes.OFFER_FETCH_SUCCESS;
      offer: Offer;
    }
  | {
      type: LGActionTypes.OFFER_FETCH_ERROR;
      priceId: string;
      error?: ApiError;
    };
